import { render, staticRenderFns } from "./conf_api.vue?vue&type=template&id=67f707ff&scoped=true&"
import script from "./conf_api.vue?vue&type=script&lang=js&"
export * from "./conf_api.vue?vue&type=script&lang=js&"
import style0 from "./conf_api.vue?vue&type=style&index=0&id=67f707ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f707ff",
  null
  
)

export default component.exports